module.exports = __webpack_public_path__ + "media/images/training_case9-eab981716c67c3639f77fc36624b6613.jpg";